/**
 * CheckboxField Component
 *
 * checkbox 타입 필드를 렌더링하는 컴포넌트
 * shadcn/ui Checkbox 컴포넌트 사용
 */

import { Checkbox } from '@/shared/ui/checkbox';
import { Label } from '@/shared/ui/label';

import type { BaseFieldProps } from './types';

/**
 * 체크박스 필드
 *
 * 라벨이 체크박스 옆에 표시되는 특수한 레이아웃 사용
 */
export function CheckboxField({ field, value, onChange, disabled, error }: BaseFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Checkbox
          id={field.id}
          disabled={disabled}
          className="h-5 w-5"
          checked={(value as boolean) || false}
          onCheckedChange={(checked) => onChange(checked === true)}
        />
        <Label htmlFor={field.id} className="text-sm font-normal text-[#67696a]">
          {field.label}
        </Label>
      </div>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
